import { Col, Row } from 'antd';
import DrawerAlerts from 'Components/alerts/components/DrawerAlerts';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import FilterPopOver from 'Components/common/components/FilterPopOver';
import PeopleCardList from 'Components/common/components/PeopleCardList';
import PeopleCardListSkeleton from 'Components/common/skeleton/PeopleCardListSkeleton';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import NavBarPrimary from 'Components/layout/headers/NavBarPrimary';
import DragWrapper from 'Components/people/components/DragWrapper';
import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  notableStaffCompanyName,
  selectNotableSelectedFilters,
  selectNotableStaff, selectNotableStaffCount,
  selectNotableStaffExportLoading,
  selectNotableStaffFilters,
  selectNotableStaffFiltersLoading,
  selectNotableStaffLoading, selectNotableStaffPage,
} from 'Selector/CompaniesSelector';
import CompanyStyle from 'Style/CompanyStyle';
import FeedStyle from 'Style/FeedStyle';
import styled from 'styled-components';
import { Filter } from 'Types/FilterTypes';
import {
  allValueInKeyOfArrayExists, anyValueInKeyOfArrayExists, backgroundColorParsing,
  formatNumberWithCommas, IsTablet,
} from 'Utils/UtilityFunctions';
import {
  maxMobile, maxTablet, maxWidth, primaryHeadingColor, retina, secondaryFont, wLight,
} from 'Utils/utilsStyle';
import { actions as groupActions } from 'Slice/GroupsSlice';
import GlobalButton from 'Components/common/components/GlobalButton';
import ExportIcon from 'Components/common/assets/svgIcons/ExportIcon';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import { FILE_DOWNLOAD_FAIL, FILE_DOWNLOAD_SUCCESS } from 'Utils/Constants';
import { actions as helperActions } from 'Slice/HelperSlice';
import { selectLoaded, selectDisclessPersonality } from 'Selector/GlobalSearchContentSelector';
import { actions } from '../../Slice/CompaniesSlice';

const Wrapper = styled.div`
  .tabsNav {
    margin-top: 25px;
  }
  h2{
  color:${primaryHeadingColor};
  font-size:28px;
  font-weight:${wLight};
  font-family:${secondaryFont};
  margin-bottom:25px;
  @media all and (max-width: ${maxMobile}) {
   font-size: 20px; 
  }
}
  .heading-text {
   display:flex;
   justify-content:space-between;
  }
  .tabSection {
    margin-top: 25px;
  }
  header{
    .tabsNav {
      margin-top: 0px;
      .heading-inner-page{
        margin-bottom:0;
      }
    }
  }
  .notable-staff-filter-wrapper {
    h2.primary-color {
      margin-bottom: 0px !important;
    }
    .tabs-wrapper {
      &.resolution-filter-popover {
        .ant-btn {
          gap: 0px;
        }
      }
    }
  /* .export_btn{
    padding: 5px 15px 5px 15px;
  } */
  }
  .ant-popover .upperPart h2 {
    margin-bottom: 0 !important ;
  }
  .export-notable {
    .export_btn {
        svg {
          width: 17px;
          min-width: 17px;
          margin-right: 10px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            width: 12px;
            min-width: 12px;
          }
        }
      }
    @media all and (max-width: ${maxTablet}){ 
      width: 30px;
      margin-left: 10px;
      .export_btn {
        width: 30px;
        height: 28px;
        padding: 0px 9px;
        margin-right: 10px !important;
        margin-left: 00px;
        svg {
          width: 11px;
          min-width: 11px;
        }
      }
    }
  }
  .showTabs {
    display: none;
  }
`;

const CompanyNotableStaff = function CompanyNotableStaff() {
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);

  const notableStaff = useSelector(selectNotableStaff);
  const notableStaffPage = useSelector(selectNotableStaffPage);
  const notableStaffLoading = useSelector(selectNotableStaffLoading);
  const count = useSelector(selectNotableStaffCount);
  const formattedNotableStaffCount = formatNumberWithCommas(count);
  const staffCompanyName = useSelector(notableStaffCompanyName);
  const staffFiltersLoading = useSelector(selectNotableStaffFiltersLoading);
  const staffFilters = useSelector(selectNotableStaffFilters);
  const selectedFilters = useSelector(selectNotableSelectedFilters);
  const [filters, setFilters] = useState<Filter[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [appliedFilters, setAppliedFilters] = useState<Filter[]>([]);
  const isTab = IsTablet();
  const [previousNewsFiltersApplied, setPreviousNewsFiltersApplied] = useState<Filter[]>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const searchTopicLoaded = useSelector(selectLoaded);
  const notableStaffExportLoading = useSelector(selectNotableStaffExportLoading);

  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');

  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    if (companyIdParsed !== 0 && notableStaff.length < 1) {
      dispatch(actions.getNotableStaff({
        page: 1,
        companyId: companyIdParsed,
      }));
    }
  }, [companyIdParsed]);
  useEffect(() => {
    if (selectedFilters.length > 1) {
      setFilters(selectedFilters);
      setSelectAll(allValueInKeyOfArrayExists(selectedFilters, 'isSelected', true));
    } else {
      setFilters(staffFilters);
      setPreviousNewsFiltersApplied(staffFilters);
      setSelectAll(allValueInKeyOfArrayExists(staffFilters, 'isSelected', true));
    }
  }, [staffFilters]);
  const onChangeFilters = (flag: boolean, id: string) => {
    const tempFilters = filters.map((filter) => {
      if (filter.filterId === id) {
        return { ...filter, isSelected: flag };
      } return filter;
    });

    setFilters(tempFilters);
    setSelectAll(allValueInKeyOfArrayExists(tempFilters, 'isSelected', true));
  };
  const selectOrUnselectAll = (flag: boolean) => {
    const tempFilters = filters.map((filter) => ({ ...filter, isSelected: flag }));
    setFilters(tempFilters);
  };

  const onClickHandler = () => {
    selectOrUnselectAll(!selectAll);
    setSelectAll(!selectAll);
  };
  const checkForApplyFilter = () => {
    for (let i = 0; i < filters.length; i += 1) {
      if (filters[i].isSelected !== previousNewsFiltersApplied[i]?.isSelected) return false;
    }
    return true;
  };
  const fetchPeople = () => {
    dispatch(actions.getNotableStaff({
      page: notableStaffPage,
      companyId: companyIdParsed,
      ...selectedFilters.length && { filters },
    }));
  };
  const applyFilterHandler = () => {
    dispatch(actions.getNotableStaff({
      page: 1,
      companyId: companyIdParsed,
      filters,
    }));
    setPreviousNewsFiltersApplied(filters);
    setAppliedFilters(filters.filter((filter) => filter.isSelected === true));
    if (anyValueInKeyOfArrayExists(filters, 'isSelected', false)) {
      setIsFilterActive(true);
    } else {
      setIsFilterActive(false);
    }
  };

  const handleExport = () => {
    const obj = {
      companyId: companyIdParsed,
      companyName: staffCompanyName,
      ...(appliedFilters.length > 0 && appliedFilters.length < 16
        ? { filters: appliedFilters } : {}),
    };
    dispatch(actions.getExportNotableStaff(obj));
  };

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  const isDrag = (a: boolean) => {
    if (a) dispatch(groupActions.setDropComplete(false));
    setDragging(a);
  };

  useEffect(() => {
    setShowNew(false);
    setOpenCreateModal(dragging);
  }, [dragging]);

  return (
    <Wrapper>
      <CompanyStyle />
      <FeedStyle />
      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap">
          <BackIcon onClick={() => { navigate(-1); }} />
          <h1 className="heading text-truncate-two-line">
            {staffCompanyName.length > 0 && staffCompanyName}
          </h1>
        </div>
        <div className="right-side-wrap">
          {staffFilters.length > 0
            && (
              <div className="d-flex showTabs">
                <FilterPopOver
                  loading={staffFiltersLoading}
                  filters={filters}
                  iconMode
                  selectAll={selectAll}
                  disableApplyBtn={checkForApplyFilter()}
                  onChangeFilters={onChangeFilters}
                  onClickHandler={onClickHandler}
                  applyFilterHandler={applyFilterHandler}
                />
                <GlobalButton
                  IconRight={<ExportIcon />}
                  buttonClassName="scc-place export"
                  onButtonClick={handleExport}
                  innerSpace="0 0 0 0"
                  disabledOutline
                  disabled={!notableStaff.length}
                />
              </div>
            )}
          <GlobalSearch iconMode={isTab} />
          <DrawerAlerts />
          <AccountPopOver />
        </div>

      </NavBarPrimary>
      <div className="container">
        <DrawerPeopleGroup
          openNewCreate={openCreateModal}
          setOpenNew={toggle}
          showNew={showNew}
          toggleShowNew={(bool: boolean) => setShowNew(bool)}
          noButton
          drag={dragging}
        />
        <div className="staff-i-follow">
          <div className="mt-c-50 mb-c-20 heading-text">
            <h2 className="mb-0">
              {`Also Viewed at ${`(${formattedNotableStaffCount || 0})`}`}
            </h2>
            <div className="staff-btn-style notable-staff-filter-wrapper d-flex align-items-center">
              {
                (searchTopicLoaded && disclessPersonality) ? null : (
                  searchTopicLoaded
                  && (
                    <FilterPopOver
                      filters={filters}
                      loading={notableStaffLoading}
                      disableApplyBtn={checkForApplyFilter()}
                      selectAll={selectAll}
                      onChangeFilters={onChangeFilters}
                      onClickHandler={onClickHandler}
                      applyFilterHandler={applyFilterHandler}
                      iconMode={isTab}
                      isActive={isFilterActive}
                    />

                  )
                )
              }
              {notableStaffLoading && !notableStaff.length
                ? <SkeletonCustom width="104px" height="37px" margin="0 0 0 24px" />
                : (
                  <div
                    className="export-notable"
                  >
                    <GlobalButton
                      title="Export"
                      textColor="#7E7E7E"
                      bgColor="#fff"
                      outlineColor="#DADADA"
                      innerSpace="9px 15px 9px 15px"
                      PaddingSm="6px 15px 6px 15px"
                      LeftSpace="15px"
                      IconLeft={<ExportIcon />}
                      buttonClassName="share-button mr-0 export_btn"
                      rightSeparatorClassName="right-separator-class"
                      onButtonClick={handleExport}
                      disabled={notableStaffExportLoading || !notableStaff.length}
                    />
                  </div>
                )}
            </div>
          </div>
          {notableStaff.length ? (
            <InfiniteScroll
              hasMore
              dataLength={notableStaff?.length ?? 0}
              next={fetchPeople}
              loader={false}
              className="o-x-hidden o-y-hidden"
            >
              <Row gutter={[24, 10]} className="mb-c-50">
                {notableStaff.map((staff) => (
                  <Col span={8} xs={24} sm={24} md={12} lg={8}>
                    <DragWrapper
                      key={staff.personId}
                      isDrag={isDrag}
                    >
                      <PeopleCardList
                        executive={staff}
                        key={staff.personId}
                        disableNavigation={false}
                        personName={staff.personName}
                        logo={staff.personImage}
                        persona={staff.archeType.color}
                        tag={staff.personDesignation}
                        personAddedFlag={staff.personAdded}
                        personId={staff.personId}
                        executiveType={staff.executiveType}
                        companyName={staff.companyName}
                        personalityTypesColors={staff.personalityTypes}
                        wrapperColor={
                          backgroundColorParsing(staff.personalityTypes)
                        }
                        showDrawerIcon={!!staff.personNotes}
                      />
                    </DragWrapper>
                  </Col>
                ))}
              </Row>
            </InfiniteScroll>
          ) : !notableStaffLoading
          && (
            <NoPersonsFound
              peopleNotInFilter
              title="No person available based on this filter. Please chose a different option"
            />
          )}
        </div>
        {notableStaffLoading
          && (
            <div className="mb-2">
              <div className="mt-2">
                <Row gutter={[24, 10]} className="mb-c-50">
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(() => (
                    <Col span={8} xs={24} sm={24} md={12} lg={8}>
                      <PeopleCardListSkeleton />
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          )}
      </div>
    </Wrapper>
  );
};

export default CompanyNotableStaff;
